import {IDisplayObjectConfig} from '@gongxigames/framework/core/types/IDisplayObjectConfig';

export interface IHitArea {
    x: number;
    y: number;
}

export interface ICircleHitArea extends IHitArea {
    type: 'circle';
    radius: number;
}

export interface IRectangleHitArea extends IHitArea {
    type: 'rectangle';
    width: number;
    height?: number;
}

export interface ISpineButtonConfig extends IDisplayObjectConfig {
    spineName: string;
    animationNames: {
        hoverStart: string;
        hoverEnd: string;
        click: string;
        idle?: string;
    };
    trackIndex?: number;
    hitarea?: ICircleHitArea | IRectangleHitArea;
}
